import React, { useState, useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../lib/auth-context';
import { usePassCodeur } from '../lib/pass-codeur-context';
import { getCourseByIdStatic } from '../pages/cours/courses-data';

const CourseProtectedRoute = ({ children }) => {
  const { currentUser } = useAuth();
  const { hasAccessToCourses, isLoading } = usePassCodeur();
  const location = useLocation();
  const [courseInfo, setCourseInfo] = useState(null);
  
  // Extraire l'ID du cours depuis l'URL
  const pathParts = location.pathname.split('/');
  const courseId = pathParts[2] ? decodeURIComponent(pathParts[2]) : null; // /cours/{courseId}/chapitreId
  
  // Charger les informations du cours
  useEffect(() => {
    if (courseId) {
      try {
        const course = getCourseByIdStatic(courseId);
        setCourseInfo(course);
      } catch (error) {
        console.error('Erreur lors du chargement des infos du cours:', error);
        setCourseInfo(null);
      }
    }
  }, [courseId]);
  
  // Fonction pour vérifier l'accès au cours
  const hasAccessToCourse = () => {
    if (!courseInfo) return false;
    return courseInfo.isFree || hasAccessToCourses();
  };

  // Afficher un loading pendant la vérification du Pass Codeur ou des infos du cours
  if (isLoading || !courseInfo) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary"></div>
      </div>
    );
  }

  // Rediriger vers la page de connexion si l'utilisateur n'est pas connecté
  if (!currentUser) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Rediriger vers l'introduction du cours si l'utilisateur n'a pas accès au cours
  if (!hasAccessToCourse()) {
    if (courseId) {
      // Rediriger vers l'introduction du cours actuel
      return <Navigate to={`/cours/${courseId}`} state={{ from: location }} replace />;
    } else {
      // Fallback vers la page Pass Codeur si on ne peut pas extraire l'ID du cours
      return <Navigate to="/pass-codeur" state={{ from: location }} replace />;
    }
  }

  return children;
};

export default CourseProtectedRoute; 